import React from "react";

import { SectionPage } from "./section";

export const CollectionPage = props => <SectionPage {...props} />;
